<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        isEmpty?: boolean;
        children?: Snippet;
    }

    let { isEmpty = false, children }: Props = $props();
</script>

<div class="reptile-price__saleTags" style={isEmpty ? 'display: none' : undefined}>
    {@render children?.()}
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;
    .reptile-price {
        &__saleTags {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            gap: tokens.$oc-semantic-spacing-absolute-50;
            width: 100%;
            margin: tokens.$oc-semantic-spacing-absolute-25 0 0;
        }
    }
</style>
